import { Component, Input } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-progress-ring',
  templateUrl: './progress-ring.component.html',
  styleUrls: ['./progress-ring.component.scss']
})
export class ProgressRingComponent {

  @Input({required: true})
  public progress!: number;

  @Input({required: true})
  public text!: string;
}
